<template>
   <dashboard-layout>
       <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                <!-- <input type="search" class="form-control" placeholder="Search"> -->
                <span class="input-group-btn">
                    <!-- <button class="btn"><i class="fa fa-search"></i></button> -->
                </span><!-- input-group-btn -->
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <!-- <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div> -->
                <div class="sh-pagetitle-title"> 
                    <h2>Weborders</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div class="row row-sm">
                    <div class="card bd-primary col-12  mg-t-20">
                        <div class="card-header bg-primary tx-white">
                            <a href="/create-order" class="float-right btn btn-success">
                                <i class="fa fa-plus"></i> Nieuwe order
                            </a>
                        </div>
                        <div class="card-body pd-sm-30">
                            <div class="table-wrapper">
                            <table id="datatable2" class="table table-striped table-bordered display responsive nowrap">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Ordernummer</th>
                                        <th>Datum Order</th>
                                        <th>Organisatie</th>
                                        <th>Aantal Producten</th>
                                        <th>Prijs</th>
                                        <th>Status</th>
                                        <th>Factuurnummer</th>
                                        <th>Bewerkt Door</th>
                                        <!-- <th>Acties</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <button @click="search()" class="btn btn-success"><i class="fa fa-search"></i></button>
                                        </td>
                                        <td v-for="(item,index) in attrlist" :key="index">
                                            <select v-if="item=='order_status'" type="text" v-model="attr.find(d=>d.attribute == item).value" class="form-control">
                                                <option value="">-- SELECTEER --</option>
                                                <option value="ENQUIRIE">ENQUIRIE</option>
                                                <option value="INIT">INIT</option>
                                                <option value="CREATED">CREATED</option>
                                                <option value="PICKING">PICKING</option>
                                                <option value="PENDING">PENDING</option>
                                                <option value="EXPIRED">EXPIRED</option>
                                                <option value="OPEN">OPEN</option>
                                                <option value="CANCELLED">CANCELLED</option>
                                                <option value="CLOSED">CLOSED</option>
                                                <option value="SENT">SENT</option>
                                                <option value="INVOICED">INVOICED</option>
                                                <option value="PAID_BANK">PAID_BANK</option>
                                                <option value="PAID_CASH">PAID_CASH</option>
                                                <option value="SHIPPED">SHIPPED</option>
                                                <option value="RETURNED">RETURNED</option>
                                                <option value="COMBINE">COMBINE</option>
                                            </select>
                                            <input v-else-if="attr.find(d=>d.attribute == item)" type="text" v-model="attr.find(d=>d.attribute == item).value" class="form-control" v-on:keyup.enter="search">
                                            <div v-else></div>
                                        </td>
                                    </tr>
                                    <tr v-if="loading.status">
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <div class="" >
                                                <div class="d-flex pos-relative align-items-center">
                                                    <div style="margin:0px" class="sk-rotating-plane bg-gray-800"></div>
                                                </div>
                                            </div>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th> 
                                        <th></th> 
                                    </tr>
                                    <tr v-for="(item,index) in orders" :key="index">
                                        <td>
                                            <a  :href="'/edit-order/'+item.id" class="btn btn-warning"><i class="fa fa-edit"></i></a>
                                            <a href="#" @click="omzetten($event, item.id)" class="btn btn-primary">
                                                Naar order omzetten
                                            </a>
                                        </td>
                                        <td>{{item.id}}</td>
                                        <td>{{item.order_date}}</td>
                                        <td v-if="item.organization">
                                            {{item.organization.name}}
                                        </td>
                                        <td v-else></td>
                                        <td>{{ item.num_products }}</td>
                                        <td>{{formatPrice(item.order_total)}}</td>
                                        <td>{{item.order_status}}</td>
                                        <td>{{item.invoice_number}}</td>
                                        <td>{{item.editor_name}}</td>
                                        
                                    </tr>
                                </tbody>
                            </table>
                            </div><!-- table-wrapper -->
                        </div><!-- card-body -->
                    </div> 
                </div>
            </div>
       </div>
   </dashboard-layout>
</template>

<script>
import dashboardLayout from '../layouts/dashboard_layout'

import { mapState } from 'vuex'
export default {
    name:'orders',
    components:{
        dashboardLayout
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        })
    },
    data(){
        return {
            orders:[],
            order_id:0, 
            attr:[
                {
                    attribute:'id',
                    value:''
                },
                {
                    attribute:'order_date',
                    value:''
                },
                {
                    attribute:'organization',
                    value:''
                },
                {
                    attribute:'order_status',
                    value:'PENDING'
                },
                {
                    attribute:'invoice_number',
                    value:''
                },
                {
                    attribute:'type',
                    value:'QUOTE'
                },
            ],
            attrlist:['id','order_date','organization','num_products','price','order_status','invoice_number','editor_name']
        }
    },
    created(){
        this.$store.state.loading.status=true;
        this.$store.dispatch('get',this.endpoint+'vue/weborders')
        .then((data)=>{
            console.log(data);
            this.orders=data.data; 
            setTimeout(()=>{
                window.$("#dataTable2").DataTable();
            },500);
            this.$store.state.loading.status=false; 
        })
        .catch((error)=>{
            console.log(error.request);
            this.$store.state.loading.status=false;
        })
    },
    mounted(){ 
    },
    methods:{
        search(){
            if(this.$store.state.loading.status){ return false; }
            console.log('search', this.attr);
            this.$store.state.loading.status=true; 
            this.$store.dispatch('post',{
                details:{search:this.attr},
                endpoint:this.endpoint+'vue/orders/search' 
             })
            .then((data)=>{
                console.log(data);
                 this.orders=data.data;
                this.$store.state.loading.status=false; 
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            })
        },
        
        omzetten(e, order_id){
            e.preventDefault();
            if(!confirm('Weet je zeker dat je deze weborder om wilt zetten naar een order?')){ return false; }

            this.$store.dispatch('get',this.endpoint+'vue/changeorder/'+order_id+'/to/order/open')
            .then((data)=>{
                if(data.data.error){
                    alert(data.data.errorMessage);
                }else{
                    window.location.href="edit-order/"+data.data.order_id;
                }
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            });
        }
    }
}
</script>